__turbopack_context__.v({
  "one-click-option": "OneClickOptions-module-scss-module__E3QEha__one-click-option",
  "one-click-option-disabled": "OneClickOptions-module-scss-module__E3QEha__one-click-option-disabled",
  "one-click-text-option": "OneClickOptions-module-scss-module__E3QEha__one-click-text-option",
  "text-icon-btn": "OneClickOptions-module-scss-module__E3QEha__text-icon-btn",
  "text-icon-btn-description": "OneClickOptions-module-scss-module__E3QEha__text-icon-btn-description",
  "text-icon-btn-disabled": "OneClickOptions-module-scss-module__E3QEha__text-icon-btn-disabled",
  "text-icon-btn-title": "OneClickOptions-module-scss-module__E3QEha__text-icon-btn-title",
});
